import type * as Panel2 from '@wandb/weave/components/Panel2/panel';

import {createPreloadableLazyComponent} from '../../../../util/lazyImport';

const inputType = 'artifact' as const;

export const Spec: Panel2.PanelSpec = {
  id: 'artifact-collection',
  displayName: 'Artifact',
  Component: createPreloadableLazyComponent(() => import('./component'))
    .Component,
  inputType,
};
